export default function FindingCategoriesController(
  $filter,
  $rootScope,
  $scope,
  $timeout,
  alerts,
  amDataService,
  amSharedModelService,
  editFindingCategoryDialog,
  loaderService,
  ssDialogService,
) {
  const vm = this;

  // Attach Event Handlers
  vm.handleExpandFindingCategories = _handleExpandFindingCategories;
  vm.handleAddFindingCategory = _handleAddFindingCategory;
  vm.handleGeneratePackage = _handleGeneratePackage;
  vm.handleDownloadPackage = _handleDownloadPackage;
  vm.handleImportedFindingCategories = _handleImportedFindingCategories;
  vm.refreshFindingCategories = _refreshFindingCategories;

  _init();

  /** **********************************************
   * Event Handlers
   */

  function _handleExpandFindingCategories() {
    if (!vm.isExpanded) {
      _loadFindingCategories().then(() => {
        vm.isExpanded = true;
      });
    } else {
      vm.isExpanded = false;
    }
  }

  function _handleImportedFindingCategories() {
    // TODO: importDocumentDialog should return findingCategories model collection, then append instead of fetch
    _loadFindingCategories(true);
  }

  function _handleAddFindingCategory($event) {
    ssDialogService.dialogs.auditTrail.editFindingCategoryDialog = ssDialogService.alert(
      editFindingCategoryDialog.getOptions($event, {
        customerId: vm.customerId,
        findingCategory: {
          auditId: vm.auditId,
          findingCategoryId: 0,
        },
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.editFindingCategoryDialog);
  }

  /*
  function _handleCreatePackageFileList($event) {
    return amDataService.generateFindingPackageFileList(vm.auditId).then(function (response) {
      alerts.success('The Finding Package File List has been successfully generated. '+
      'Please run the Audit Package File List Report to view the results.');
    });
  }
  */

  function _handleGeneratePackage() {
    return amDataService.createFindingPackageFileGenerationRequest(vm.auditId).then(() => {
      alerts.success('The Finding Package has been successfully requested. '
        + 'You will receive an email notification when the file generation is complete.');
      vm.hasAuditPackageGenerationRequests = true;
    });
  }

  function _handleDownloadPackage() {
    alerts.success('Download Package has been requested. Package download will start momentarily.');
    amDataService.downloadPackage(vm.auditPackageId).then((packageResponse) => {
      amDataService.download(packageResponse);
    });
  }

  function _refreshFindingCategories() {
    _loadFindingCategories(true);
  }

  /** **********************************************
   * Private Functions
   */

  function _init() {
    vm.canExpand = true;
    vm.isExpanded = false;
    vm.hasData = false;
    vm.canEditItem = vm.canEdit && vm.auditIsActive;
    vm.canDeleteItem = vm.canDelete && vm.auditIsActive;
    vm.canGenerateItemPackage = vm.canGeneratePackage && vm.auditIsActive;
    vm.canDownloadItemPackage = vm.canDownloadPackage && vm.hasActiveAuditPackage;
    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshAMFindingCategories', (event, opt) => {
      if (opt.auditId === vm.auditId) {
        _loadFindingCategories(true);
      }
    });
  }

  function _setNoItemMessage() {
    if (vm.findingCategories.length === 0) {
      vm.noItemMessage = 'There are currently no Findings for you to contribute to in this Audit.';
    } else {
      vm.noItemMessage = 'There are no Findings yet. Please import or add Findings.';
    }
  }

  function _loadFindingCategories(forceRefresh = false) {
    loaderService.showViewLoader = true;
    return amSharedModelService.getFindingCategories(vm.auditId, forceRefresh)
      .then((findingCategories) => {
        loaderService.showViewLoader = false;
        vm.findingCategories = findingCategories;
        _setNoItemMessage();
      });
  }
}

FindingCategoriesController.$inject = [
  '$filter',
  '$rootScope',
  '$scope',
  '$timeout',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'editFindingCategoryDialog',
  'loaderService',
  'ssDialogService',
];
